
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { useEffect } from 'react';
import { UserDefault, UserSession } from '@src/lib';

import { MARKETING_MATURE } from '@src/view/components/viewer/data';
import { TopcoPartner } from '@src/lib/marketing/TopcoPartner';
import _ from 'lodash';
import dynamic from 'next/dynamic';
import { isRefererCheck } from '@src/lib/utils/utils';
import useLogin from '@src/hooks/useLogin';
import { useRouter } from 'next/router';
import {
  getComicData,
  getFirstEpisode,
  getViewSignedCookies,
} from '@src/server/comicData';
import Seo, { GoogleSearchData } from '@src/seo/Seo';
import { CompanyInfo } from '@src/constants';

const Episode = dynamic<any>(
  () =>
    import('@src/view/components/episode').then(
      (mod: any) => mod.EpisodeComponent,
    ),
  {
    ssr: false,
  },
);

const Index = (props: any) => {
  const { comic, isReferer, data, p_id } = props;
  const router = useRouter();
  const { showJoinAndLoginModal } = useLogin();

  // login 모달 띄우는 액션 추가 -> Omeman 사이트에서 회차리스트로 유입했을 때 사용중
  // fe.toptoonplus.com.prologue 프로젝트 참고
  useEffect(() => {
    const { action, targetUrl } = router.query;
    const { token } = UserSession.getUserInfo();

    if (!action || action !== 'login') {
      history.replaceState({}, '', location.pathname);
      return;
    }

    // 로그인 상태
    if (token) {
      history.replaceState('', `/comic/${comic}`);
      if (targetUrl) {
        window.location.replace(`/comic/${comic}/${targetUrl}`);
      } else {
        window.location.replace(`/comic/${comic}`);
      }
      return;
    }

    history.replaceState('', `/comic/${comic}`);
    if (targetUrl) {
      showJoinAndLoginModal(`/comic/${comic}/${targetUrl}`);
    } else {
      showJoinAndLoginModal(`/comic/${comic}`);
    }
  }, []);

  return (
    <>
      <Seo
        title={`${data.title} ｜ ${CompanyInfo.NAME_UPPER_CASE} - Daily Updated Popular Web comics`}
        description={data.description}
        canonical={`${process.env.REACT_APP_PUBLIC_URL}/comic/${comic}`}
        searchData={GoogleSearchData({
          title: data.title,
          url: `${process.env.REACT_APP_PUBLIC_URL}/comic/${comic}`,
          description: data.description,
          image: data.thumbnail17,
          author: data.author,
        })}
      />
      <Episode
        marketingMature={MARKETING_MATURE.NON_ADULT}
        comicId={comic}
        isReferer={isReferer}
        comicTitle={data.title}
        p_id={p_id}
      />
    </>
  );
};

 async function _getServerSideProps(context: any) {
  const { query } = context;

  const ret = await TopcoPartner.setterSSR(context);
  if (ret) {
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  }

  const { comicId, p_id } = query;
  const isReferer = isRefererCheck(context);

  let comic: number = 0;

  if (comicId && !_.isNaN(Number(comicId))) {
    comic = Number(comicId);
  }

  if (comic === 0) {
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  }

  try {
    const data = await getComicData(Number(comic));

    // 영상 작품(comicType === 3) 최초 진입 시 1화 서명쿠키 발급 (배너 프리뷰 재생용).
    //   /comic 은 광고접속(p_id 진입점) → setterSSR 이 방금 세팅한 파트너쿠키(Set-Cookie)를
    //   덮어쓰면 안 되므로 setHeader(교체) 대신 appendHeader(추가) 사용. (content 와 다른 점)
    if (Number(data.comicType) === 3) {
      const firstEpisode = await getFirstEpisode(comic);
      // 1화가 순수 무료(coin === 0)일 때만 서명쿠키 발급
      if (firstEpisode && firstEpisode.coin === 0) {
        const viewSigned = await getViewSignedCookies({
          comicId: comic,
          episodeId: firstEpisode.episodeId,
        });
        if (viewSigned !== null && viewSigned?.data?.signedCookies) {
          context.res.appendHeader('Set-Cookie', [
            `CloudFront-Key-Pair-Id=${viewSigned?.data?.signedCookies['CloudFront-Key-Pair-Id']}; path=/; domain=.toptoon.com; httpOnly; secure; SameSite=None`,
            `CloudFront-Policy=${viewSigned?.data?.signedCookies['CloudFront-Policy']}; path=/; domain=.toptoon.com; httpOnly; secure; SameSite=None`,
            `CloudFront-Signature=${viewSigned?.data?.signedCookies['CloudFront-Signature']}; path=/; domain=.toptoon.com; httpOnly; secure; SameSite=None`,
          ]);
        }
      }
    }

    return {
      props: {
        isReferer,
        data,
        comic,
        p_id: p_id ?? null,
      },
    };
  } catch (err) {
    console.error(err);
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  }
}

export default Index;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/comic/[comicId]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  